import styled from '@emotion/styled';

export const ConsumerAddBankFormContainer = styled.div`
  position: relative;
`;
